import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

/* istanbul ignore next */
export const SerialCodeInputModal = universal(
    universalImport({
        chunkName: () => 'CouponsModuleLazy',
        path: () =>
            path.join(
                __dirname,
                'yoda-checkout-components/lib/components/Coupons/SerialCodeInputModal/SerialCodeInputModal'
            ),
        resolve: () =>
            require.resolveWeak(
                'yoda-checkout-components/lib/components/Coupons/SerialCodeInputModal/SerialCodeInputModal'
            ),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "CouponsModuleLazy" */ 'yoda-checkout-components/lib/components/Coupons/SerialCodeInputModal/SerialCodeInputModal'
                ),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
    }
);

/* istanbul ignore next */
export const CouponsPanel = universal(
    universalImport({
        chunkName: () => 'CouponsModuleLazy',
        path: () =>
            path.join(__dirname, 'yoda-checkout-components/lib/components/Coupons/CouponsPanel'),
        resolve: () =>
            require.resolveWeak('yoda-checkout-components/lib/components/Coupons/CouponsPanel'),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "CouponsModuleLazy" */ 'yoda-checkout-components/lib/components/Coupons/CouponsPanel'
                ),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
    }
);

/* istanbul ignore next */
export const ShowRewardsPanel = universal(
    universalImport({
        chunkName: () => 'CouponsModuleLazy',
        path: () =>
            path.join(
                __dirname,
                'yoda-checkout-components/lib/components/ShowRewardsPanel/ShowRewardsPanel'
            ),
        resolve: () =>
            require.resolveWeak(
                'yoda-checkout-components/lib/components/ShowRewardsPanel/ShowRewardsPanel'
            ),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "CouponsModuleLazy" */ 'yoda-checkout-components/lib/components/ShowRewardsPanel/ShowRewardsPanel'
                ),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
    }
);

/* istanbul ignore next */
export const SessionTimeoutModal = universal(
    universalImport({
        chunkName: () => 'SessionTimeoutModalLazy',
        path: () =>
            path.join(
                __dirname,
                'yoda-checkout-components/lib/components/SessionTimeoutModal/SessionTimeoutModal'
            ),
        resolve: () =>
            require.resolveWeak(
                'yoda-checkout-components/lib/components/SessionTimeoutModal/SessionTimeoutModal'
            ),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "SessionTimeoutModalLazy" */ 'yoda-checkout-components/lib/components/SessionTimeoutModal/SessionTimeoutModal'
                ),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
    }
);

/* istanbul ignore next */
export const OOSModal = universal(
    universalImport({
        chunkName: () => 'OOSModalLazy',
        path: () =>
            path.join(__dirname, 'yoda-checkout-components/lib/components/OOSModal/OOSModal'),
        resolve: () =>
            require.resolveWeak('yoda-checkout-components/lib/components/OOSModal/OOSModal'),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "OOSModalLazy" */ 'yoda-checkout-components/lib/components/OOSModal/OOSModal'
                ),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
    }
);

/* istanbul ignore next */
export const GenericOopsMessage = universal(
    universalImport({
        chunkName: () => 'GenericOopsMessageLazy',
        path: () =>
            path.join(
                __dirname,
                'yoda-checkout-components/lib/components/GenericOopsMessage/GenericOopsMessage'
            ),
        resolve: () =>
            require.resolveWeak(
                'yoda-checkout-components/lib/components/GenericOopsMessage/GenericOopsMessage'
            ),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "GenericOopsMessageLazy" */ 'yoda-checkout-components/lib/components/GenericOopsMessage/GenericOopsMessage'
                ),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
    }
);

/* istanbul ignore next */
export const ReviewShippingGroupList = universal(
    universalImport({
        chunkName: () => 'ReviewShippingGroupListLazy',
        path: () =>
            path.join(__dirname, '../components/ReviewShippingGroupList/ReviewShippingGroupList'),
        resolve: () =>
            require.resolveWeak('../components/ReviewShippingGroupList/ReviewShippingGroupList'),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "ReviewShippingGroupListLazy" */ '../components/ReviewShippingGroupList/ReviewShippingGroupList'
                ),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
    }
);

/* istanbul ignore next */
export const NewGiftCardForm = universal(
    universalImport({
        chunkName: () => 'NewGiftCardFormLazy',
        path: () =>
            path.join(
                __dirname,
                '../containers/Pages/NewPaymentPage/NewGiftCardPayment/NewGiftCardForm/NewGiftCardForm'
            ),
        resolve: () =>
            require.resolveWeak(
                '../containers/Pages/NewPaymentPage/NewGiftCardPayment/NewGiftCardForm/NewGiftCardForm'
            ),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "NewGiftCardFormLazy" */ '../containers/Pages/NewPaymentPage/NewGiftCardPayment/NewGiftCardForm/NewGiftCardForm'
                ),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
    }
);

/* istanbul ignore next */
export const NewCheckoutPage = universal(
    universalImport({
        chunkName: () => 'NewCheckoutPage',
        path: () => path.join(__dirname, '../containers/Pages/NewCheckoutPage/NewCheckoutPage'),
        resolve: () => require.resolveWeak('../containers/Pages/NewCheckoutPage/NewCheckoutPage'),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "NewCheckoutPage" */ '../containers/Pages/NewCheckoutPage/NewCheckoutPage'
                ),
            ]).then((proms) => proms[0]),
    })
);

/* istanbul ignore next */
export const NewSameDayPickupPage = universal(
    universalImport({
        chunkName: () => 'NewSameDayPickupPage',
        path: () =>
            path.join(__dirname, '../containers/Pages/NewSameDayPickupPage/NewSameDayPickupPage'),
        resolve: () =>
            require.resolveWeak('../containers/Pages/NewSameDayPickupPage/NewSameDayPickupPage'),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "NewSameDayPickupPage" */ '../containers/Pages/NewSameDayPickupPage/NewSameDayPickupPage'
                ),
            ]).then((proms) => proms[0]),
    })
);

/* istanbul ignore next */
export const NewShippingPage = universal(
    universalImport({
        chunkName: () => 'NewShippingPage',
        path: () => path.join(__dirname, '../containers/Pages/NewShippingPage/NewShippingPage'),
        resolve: () => require.resolveWeak('../containers/Pages/NewShippingPage/NewShippingPage'),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "NewShippingPage" */ '../containers/Pages/NewShippingPage/NewShippingPage'
                ),
            ]).then((proms) => proms[0]),
    })
);

/* istanbul ignore next */
export const NewPaymentPage = universal(
    universalImport({
        chunkName: () => 'NewPaymentPage',
        path: () => path.join(__dirname, '../containers/Pages/NewPaymentPage/NewPaymentPage'),
        resolve: () => require.resolveWeak('../containers/Pages/NewPaymentPage/NewPaymentPage'),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "NewPaymentPage" */ '../containers/Pages/NewPaymentPage/NewPaymentPage'
                ),
            ]).then((proms) => proms[0]),
    })
);
